import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  KR: {
    // --- 공통/메뉴 ---
    loginTitle: "JUNKET SYSTEM", loginBtn: "로그인", idPlace: "아이디", pwPlace: "비밀번호",
    menu_dashboard: "대시보드", menu_agents: "에이전트", menu_games: "게임 관리", 
    menu_reports: "정산서", menu_transactions: "트랜잭션", menu_credit: "크레딧 (Credit)", 
    menu_cage: "케이지 (Cage)", menu_settings: "시스템 설정",
    confirm: "확인", cancel: "취소", close: "닫기", save: "저장", edit: "수정", view: "상세보기",
    search: "검색", pdf: "PDF 내보내기", staff: "담당자", date: "날짜", type: "유형", amount: "금액", remark: "비고",
    action: "관리", status: "상태", active: "활성", settled: "완료",
    
    // --- 대시보드 (Dashboard) ---
    dash_title_user: "Junket Operation Dashboard", dash_sub_user: "나의 실적 및 현황",
    dash_title_admin: "Junket Operation Dashboard", dash_sub_admin: "실시간 시스템 운영 현황",
    card_my_rolling: "나의 그룹 롤링", card_wallet: "나의 지갑 잔고", card_cashflow: "나의 입출금 현황",
    card_total_rolling: "총 롤링 (Total Rolling)", card_cage_inv: "케이지 보유고 (Cage Inventory)", 
    today: "오늘 (Today)", this_month: "이번 달 (This Month)", this_year: "올해 (This Year)",
    in_deposit: "입금 (In)", out_withdraw: "출금 (Out)", net_flow: "순수익 (Net)",
    cash_chips_safe: "현금 칩 (Safe)", rolling_chips_safe: "롤링 칩 (Safe)", total_chips_bal: "총 칩 잔액",
    active_tables: "활성화된 테이블", no_active_tables: "현재 활성화된 게임 테이블이 없습니다.",
    start_new_game_msg: "[게임 관리] 메뉴에서 새로운 게임을 시작해보세요.",

    // --- 에이전트 (Agents) ---
    agent_title: "에이전트 관리", filter_all: "전체", filter_group: "그룹", filter_agent: "에이전트",
    search_place_agent: "이름 또는 ID 검색...", agent_new: "신규 생성", 
    th_id: "ID 코드", th_name: "이름", th_phone: "연락처/텔레그램", th_balance: "잔고", th_creator: "생성자",

    // --- 게임/정산 (Reports) ---
    report_title: "정산 및 리포트 (Reports)", report_sub: "기간별 수익 및 정산 내역을 확인합니다.",
    total_agents: "총 에이전트", total_active_games: "진행 중 게임", total_buyin: "총 바이인 합계", total_rolling_vol: "총 롤링 볼륨",
    settled_list: "정산 완료 내역 (Settled Games)", 
    game_view: "보기 (View)", game_enter: "입력 (Enter)",

    // --- 크레딧 (Credit) ---
    credit_title: "Credit Management (대출/상환)", 
    total_loan: "총 대출액", total_repaid: "총 상환액", total_outstanding: "현재 미수금",
    tab_all: "전체", tab_active_loan: "미상환 (Active)", tab_settled_loan: "상환완료 (Settled)",
    th_loan_id: "대출 ID", th_linked_game: "연관 게임", th_principal: "원금", th_repaid: "상환", th_re_balance: "잔액",

    // --- 케이지 (Cage) ---
    cage_balance: "현재 시재 (Cash Balance)", today_in: "금일 입금", today_out: "금일 출금",
    tab_agent_io: "에이전트 입출금", tab_expenses: "경비 (Expenses)", tab_safety: "보관 (Safety Deposit)",
    tab_vault: "금고/은행 (Vault & Bank)", tab_handover: "인수인계 (Handover)", tab_telegram: "알림 (Telegram)",
    label_agent_search: "에이전트 검색", btn_deposit: "입금 (Deposit)", btn_withdraw: "출금 (Withdraw)",
    label_amount: "금액 (Amount)", label_remark: "메모 (Remark)", btn_submit: "승인 및 처리 (Submit)",

    // --- 설정 (Settings) ---
    setting_title: "시스템 설정 (System Settings)",
    sec_env: "기본 환경 설정", lbl_lang: "시스템 언어", lbl_time: "시간대 (Timezone)", lbl_curr: "주 사용 화폐",
    lbl_comp_name: "회사명 (Company Name)", lbl_comp_logo: "회사 로고 (Company Logo)",
    sec_print: "기기 및 출력 설정", lbl_sheet: "정산서 용지", lbl_slip: "영수증/보관증 용지",
    lbl_sig: "전자 서명 패드 (Signature Pad)", btn_connect: "기기 연결 (Connect)",
    msg_connect_success: "기기가 연결되었습니다.", msg_connect_fail: "기기를 찾을 수 없습니다."
  },
  EN: {
    // --- Common/Menu ---
    loginTitle: "JUNKET SYSTEM", loginBtn: "Login", idPlace: "ID", pwPlace: "Password",
    menu_dashboard: "Dashboard", menu_agents: "Agents", menu_games: "Game Mgmt", 
    menu_reports: "Reports", menu_transactions: "Transactions", menu_credit: "Credit", 
    menu_cage: "Cage (Vault)", menu_settings: "System Setting",
    confirm: "Confirm", cancel: "Cancel", close: "Close", save: "Save", edit: "Edit", view: "Details",
    search: "Search", pdf: "Export PDF", staff: "Staff", date: "Date", type: "Type", amount: "Amount", remark: "Remark",
    action: "Action", status: "Status", active: "Active", settled: "Settled",

    // --- Dashboard ---
    dash_title_user: "Junket Operation Dashboard", dash_sub_user: "My Performance & Status",
    dash_title_admin: "Junket Operation Dashboard", dash_sub_admin: "Real-time System Status",
    card_my_rolling: "My Group Rolling", card_wallet: "My Wallet Balance", card_cashflow: "My Cash Flow",
    card_total_rolling: "Total Rolling", card_cage_inv: "Cage Inventory", 
    today: "Today", this_month: "This Month", this_year: "This Year",
    in_deposit: "In (Deposit)", out_withdraw: "Out (Withdraw)", net_flow: "Net Flow",
    cash_chips_safe: "Cash Chips (Safe)", rolling_chips_safe: "Rolling Chips (Safe)", total_chips_bal: "Total Chips Balance",
    active_tables: "Active Tables", no_active_tables: "No active game tables.",
    start_new_game_msg: "Start a new game from the [Game Mgmt] menu.",

    // --- Agents ---
    agent_title: "Agent Management", filter_all: "All", filter_group: "Group", filter_agent: "Agent",
    search_place_agent: "Search Name or ID...", agent_new: "New Agent", 
    th_id: "ID Code", th_name: "Name", th_phone: "Phone/Telegram", th_balance: "Balance", th_creator: "Creator",

    // --- Reports ---
    report_title: "Settlement & Reports", report_sub: "Check revenue and settlement history.",
    total_agents: "Total Agents", total_active_games: "Active Games", total_buyin: "Total Buy-in", total_rolling_vol: "Total Rolling",
    settled_list: "Settled Games History", 
    game_view: "View", game_enter: "Enter",

    // --- Credit ---
    credit_title: "Credit Management", 
    total_loan: "Total Loan", total_repaid: "Total Repaid", total_outstanding: "Total Outstanding",
    tab_all: "All", tab_active_loan: "Active", tab_settled_loan: "Settled",
    th_loan_id: "Loan ID", th_linked_game: "Linked Game", th_principal: "Principal", th_repaid: "Repaid", th_re_balance: "Balance",

    // --- Cage ---
    cage_balance: "Current Cash Balance", today_in: "Today In", today_out: "Today Out",
    tab_agent_io: "Agent I/O", tab_expenses: "Expenses", tab_safety: "Safety Deposit",
    tab_vault: "Vault & Bank", tab_handover: "Handover", tab_telegram: "Telegram",
    label_agent_search: "Search Agent", btn_deposit: "Deposit", btn_withdraw: "Withdraw",
    label_amount: "Amount", label_remark: "Remark", btn_submit: "Submit Transaction",

    // --- Settings ---
    setting_title: "System Settings",
    sec_env: "Basic Environment", lbl_lang: "System Language", lbl_time: "Timezone", lbl_curr: "Primary Currency",
    lbl_comp_name: "Company Name", lbl_comp_logo: "Company Logo",
    sec_print: "Devices & Print", lbl_sheet: "Settlement Sheet", lbl_slip: "Receipt/Slip Paper",
    lbl_sig: "Bluetooth Signature Pad", btn_connect: "Connect",
    msg_connect_success: "Device Connected.", msg_connect_fail: "Device Not Found."
  },
  CN: {
    // --- Common ---
    loginTitle: "中介管理系统", loginBtn: "登录", idPlace: "账号", pwPlace: "密码",
    menu_dashboard: "仪表盘", menu_agents: "代理管理", menu_games: "游戏管理", 
    menu_reports: "结算单", menu_transactions: "交易记录", menu_credit: "信用额度", 
    menu_cage: "出纳 (Cage)", menu_settings: "系统设置",
    confirm: "确认", cancel: "取消", close: "关闭", save: "保存", edit: "修改", view: "查看",
    search: "搜索", pdf: "导出PDF", staff: "职员", date: "日期", type: "类型", amount: "金额", remark: "备注",
    action: "操作", status: "状态", active: "进行中", settled: "已结算",

    // --- Dashboard ---
    dash_title_user: "运营仪表盘", dash_sub_user: "我的业绩与现状",
    dash_title_admin: "运营仪表盘", dash_sub_admin: "实时系统运营状况",
    card_my_rolling: "我的团队洗码", card_wallet: "我的钱包余额", card_cashflow: "我的资金流向",
    card_total_rolling: "总洗码量", card_cage_inv: "库存总览", 
    today: "今日", this_month: "本月", this_year: "今年",
    in_deposit: "存款 (In)", out_withdraw: "取款 (Out)", net_flow: "净流量",
    cash_chips_safe: "现金码 (保险箱)", rolling_chips_safe: "泥码 (保险箱)", total_chips_bal: "筹码总余额",
    active_tables: "活跃台桌", no_active_tables: "当前没有活跃的游戏台桌。",
    start_new_game_msg: "请在 [游戏管理] 菜单中开始新游戏。",

    // --- Agents ---
    agent_title: "代理管理", filter_all: "全部", filter_group: "总代", filter_agent: "代理",
    search_place_agent: "搜索姓名或ID...", agent_new: "新建代理", 
    th_id: "ID代码", th_name: "姓名", th_phone: "电话/Telegram", th_balance: "余额", th_creator: "创建者",

    // --- Reports ---
    report_title: "结算与报表", report_sub: "查看按期间的收益及结算详情。",
    total_agents: "总代理数", total_active_games: "进行中游戏", total_buyin: "总买入", total_rolling_vol: "总洗码量",
    settled_list: "已结算游戏记录", 
    game_view: "查看", game_enter: "进入",

    // --- Credit ---
    credit_title: "信用管理 (贷款/还款)", 
    total_loan: "总贷款额", total_repaid: "总还款额", total_outstanding: "当前未还款",
    tab_all: "全部", tab_active_loan: "未还款", tab_settled_loan: "已还清",
    th_loan_id: "贷款ID", th_linked_game: "关联游戏", th_principal: "本金", th_repaid: "还款", th_re_balance: "余额",

    // --- Cage ---
    cage_balance: "当前现金余额", today_in: "今日入款", today_out: "今日出款",
    tab_agent_io: "代理存取", tab_expenses: "费用", tab_safety: "保管箱",
    tab_vault: "金库/银行", tab_handover: "交接", tab_telegram: "通知",
    label_agent_search: "搜索代理", btn_deposit: "存款", btn_withdraw: "取款",
    label_amount: "金额", label_remark: "备注", btn_submit: "提交处理",

    // --- Settings ---
    setting_title: "系统设置",
    sec_env: "基本环境设置", lbl_lang: "系统语言", lbl_time: "时区", lbl_curr: "主要货币",
    lbl_comp_name: "公司名称", lbl_comp_logo: "公司Logo",
    sec_print: "设备与打印设置", lbl_sheet: "结算单纸张", lbl_slip: "收据纸张",
    lbl_sig: "电子签名板", btn_connect: "连接设备",
    msg_connect_success: "设备已连接。", msg_connect_fail: "未找到设备。"
  },
  JP: {
    // --- Common ---
    loginTitle: "JUNKET SYSTEM", loginBtn: "ログイン", idPlace: "ID", pwPlace: "パスワード",
    menu_dashboard: "ダッシュボード", menu_agents: "エージェント", menu_games: "ゲーム管理", 
    menu_reports: "精算書", menu_transactions: "取引履歴", menu_credit: "クレジット", 
    menu_cage: "キャッシャー", menu_settings: "設定",
    confirm: "確認", cancel: "キャンセル", close: "閉じる", save: "保存", edit: "修正", view: "詳細",
    search: "検索", pdf: "PDF出力", staff: "担当者", date: "日付", type: "タイプ", amount: "金額", remark: "備考",
    action: "管理", status: "状態", active: "進行中", settled: "完了",

    // --- Dashboard ---
    dash_title_user: "運営ダッシュボード", dash_sub_user: "私の実績と現状",
    dash_title_admin: "運営ダッシュボード", dash_sub_admin: "リアルタイムシステム状況",
    card_my_rolling: "グループローリング", card_wallet: "ウォレット残高", card_cashflow: "入出金状況",
    card_total_rolling: "総ローリング", card_cage_inv: "ケージ在庫", 
    today: "今日", this_month: "今月", this_year: "今年",
    in_deposit: "入金 (In)", out_withdraw: "出金 (Out)", net_flow: "純損益",
    cash_chips_safe: "キャッシュチップ (Safe)", rolling_chips_safe: "ローリングチップ (Safe)", total_chips_bal: "チップ総残高",
    active_tables: "アクティブなテーブル", no_active_tables: "現在アクティブなゲームテーブルはありません。",
    start_new_game_msg: "[ゲーム管理] メニューから新しいゲームを開始してください。",

    // --- Agents ---
    agent_title: "エージェント管理", filter_all: "全て", filter_group: "グループ", filter_agent: "エージェント",
    search_place_agent: "名前またはID検索...", agent_new: "新規作成", 
    th_id: "IDコード", th_name: "名前", th_phone: "連絡先/Telegram", th_balance: "残高", th_creator: "作成者",

    // --- Reports ---
    report_title: "精算およびレポート", report_sub: "期間別の収益および精算履歴を確認します。",
    total_agents: "総エージェント", total_active_games: "進行中のゲーム", total_buyin: "総バイイン", total_rolling_vol: "総ローリング",
    settled_list: "精算完了履歴", 
    game_view: "表示", game_enter: "入力",

    // --- Credit ---
    credit_title: "クレジット管理 (貸出/返済)", 
    total_loan: "総貸出額", total_repaid: "総返済額", total_outstanding: "現在未収金",
    tab_all: "全て", tab_active_loan: "未返済", tab_settled_loan: "返済完了",
    th_loan_id: "貸出ID", th_linked_game: "関連ゲーム", th_principal: "元金", th_repaid: "返済", th_re_balance: "残高",

    // --- Cage ---
    cage_balance: "現在保有現金", today_in: "本日入金", today_out: "本日出金",
    tab_agent_io: "エージェント入出金", tab_expenses: "経費", tab_safety: "保管 (Safety)",
    tab_vault: "金庫/銀行", tab_handover: "引継ぎ", tab_telegram: "通知",
    label_agent_search: "エージェント検索", btn_deposit: "入金", btn_withdraw: "出金",
    label_amount: "金額", label_remark: "備考", btn_submit: "承認および処理",

    // --- Settings ---
    setting_title: "システム設定",
    sec_env: "基本環境設定", lbl_lang: "システム言語", lbl_time: "タイムゾーン", lbl_curr: "主要通貨",
    lbl_comp_name: "会社名", lbl_comp_logo: "会社ロゴ",
    sec_print: "デバイスおよび出力設定", lbl_sheet: "精算書用紙", lbl_slip: "レシート用紙",
    lbl_sig: "電子署名パッド", btn_connect: "デバイス接続",
    msg_connect_success: "デバイスが接続されました。", msg_connect_fail: "デバイスが見つかりません。"
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('KR');
  const t = (key) => translations[lang]?.[key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);